import { teamConstants } from "../_constants/team.constants";
import { alertActions } from "./alert.actions";
import { teamService } from "../_services/team.service";

export const teamActions = {
    getAll,
    create,
    remove,
    uploadLogo
}

function getAll() {
    return dispatch => {
        dispatch(request());

        teamService.getAll()
            .then(
                data => {
                    dispatch(success(data));
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );

        function request() { return { type: teamConstants.LIST_REQUEST } }
        function success(teams) { return { type: teamConstants.LIST_SUCCESS, teams } }
        function failure(error) { return { type: teamConstants.LIST_FAILURE, error } }
    };
}

function create(form) {
    return dispatch => {
        dispatch(request());

        teamService.create(form)
            .then(
                data => {
                    dispatch(success(data));
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );

        function request() { return { type: teamConstants.CREATE_REQUEST } }
        function success(team) { return { type: teamConstants.CREATE_SUCCESS, team } }
        function failure(error) { return { type: teamConstants.CREATE_FAILURE, error } }
    };
}

function remove(teamId) {
    return dispatch => {
        dispatch(request(teamId));

        teamService.remove(teamId)
            .then(
                () => {
                    dispatch(success(teamId));
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );

        function request(teamId) { return { type: teamConstants.REMOVE_REQUEST, teamId } }
        function success(teamId) { return { type: teamConstants.REMOVE_SUCCESS, teamId } }
        function failure(error) { return { type: teamConstants.REMOVE_FAILURE, error } }
    };
}

function uploadLogo(file) {
    return dispatch => {
        dispatch(request());

        teamService.uploadLogo(file)
            .then(
                logoUrl => {
                    dispatch(success(logoUrl));
                },
                error => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                }
            );

        function request() { return { type: teamConstants.UPLOAD_LOGO_REQUEST } }
        function success(logoUrl) { return { type: teamConstants.UPLOAD_LOGO_SUCCESS, logoUrl } }
        function failure(error) { return { type: teamConstants.UPLOAD_LOGO_FAILURE, error } }
    };
}